import React from 'react';
import { LEGEND_BUCKETS } from './colors';

/**
 * Legend strip that renders the engagement color scale as a gradient bar
 * with tick labels at 0 / 25 / 50 / 75 / 100. Sits directly above the grid
 * so users can read a cell color back to a percentage at a glance.
 */
export function HeatmapLegend() {
  return (
    <div
      className="bg-bg-elevated rounded-lg border border-border-base p-4"
      data-testid="heatmap-legend"
      role="group"
      aria-label="Engagement score color scale"
    >
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-sm font-bold text-fg-primary">
          Engagement Score Scale
        </h2>
        <span className="text-[11px] text-fg-muted">
          Darker = lower conversion · Brighter green = higher
        </span>
      </div>

      {/* Gradient bar with tick labels */}
      <div className="space-y-2">
        <div
          className="h-3 rounded w-full"
          style={{
            background:
              'linear-gradient(to right, rgb(30 41 59), rgb(51 65 85), rgb(6 78 59), rgb(5 150 105), rgb(16 185 129), rgb(52 211 153))',
          }}
          aria-hidden="true"
        />
        <div className="flex justify-between text-[11px] text-fg-muted tabular-nums">
          <span>0%</span>
          <span>25%</span>
          <span>50%</span>
          <span>75%</span>
          <span>100%</span>
        </div>
      </div>

      {/* Discrete legend swatches (retained for screen readers and quick
          reference — matches the bucketed color logic actually applied to
          cells). */}
      <div className="flex gap-3 flex-wrap pt-3 border-t border-border-base mt-3">
        {LEGEND_BUCKETS.map((bucket) => (
          <div key={bucket.label} className="flex items-center gap-2">
            <div
              className={`w-5 h-5 rounded border border-border-base ${bucket.color}`}
              aria-hidden="true"
            />
            <span className="text-[11px] text-fg-secondary tabular-nums">
              {bucket.label}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
